import { create } from 'zustand';

interface SubscriptionModalState {
  isOpen: boolean;
  feature?: string;
  context?: string;
  showModal: (payload?: { feature?: string; context?: string }) => void;
  hideModal: () => void;
}

export const useSubscriptionModalStore = create<SubscriptionModalState>()((set) => ({
  isOpen: false,
  feature: undefined,
  context: undefined,
  showModal: (payload) =>
    set({
      isOpen: true,
      feature: payload?.feature,
      context: payload?.context,
    }),
  hideModal: () =>
    set({
      isOpen: false,
      feature: undefined,
      context: undefined,
    }),
}));
